/** The PricePilot mark: a compass ring with a single gold needle. Flat, one colour plus gold. */
export function Mark({ size = 28, onDark = false, className }: { size?: number; onDark?: boolean; className?: string }) {
  const ring = onDark ? '#ffffff' : 'rgb(var(--accent))'
  const gold = onDark ? '#d6a84e' : 'rgb(var(--gold))'
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} role="img" aria-label="PricePilot">
      <circle cx="50" cy="50" r="36" fill="none" stroke={ring} strokeWidth="8" />
      <circle cx="50" cy="50" r="5" fill={ring} />
      <path d="M50 50 L66 22 L58 50 Z" fill={gold} />
      <path d="M50 50 L34 78 L42 50 Z" fill={ring} opacity=".45" />
    </svg>
  )
}

/** The mark on a navy tile, as in the favicon — for corners and app icons. */
export function Tile({ size = 34, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} role="img" aria-label="PricePilot">
      <rect width="100" height="100" rx="22" fill="rgb(var(--accent))" />
      <circle cx="50" cy="50" r="30" fill="none" stroke="rgb(var(--accent-contrast))" strokeWidth="8" />
      <circle cx="50" cy="50" r="5" fill="rgb(var(--accent-contrast))" />
      <path d="M50 50 L63 27 L57 50 Z" fill="#d6a84e" />
      <path d="M50 50 L37 73 L43 50 Z" fill="rgb(var(--accent-contrast))" opacity=".45" />
    </svg>
  )
}

export function Wordmark({ size = 15, onDark = false }: { size?: number; onDark?: boolean }) {
  return (
    <span className="font-semibold tracking-tight" style={{ fontSize: size, color: onDark ? '#fff' : 'rgb(var(--s50))' }}>
      Price
      <span style={{ color: onDark ? '#cfe0f5' : 'rgb(var(--accent))' }}>Pilot</span>
    </span>
  )
}

export function Logo({ size = 28, onDark = false, wordSize = 15 }: { size?: number; onDark?: boolean; wordSize?: number }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <Mark size={size} onDark={onDark} />
      <Wordmark size={wordSize} onDark={onDark} />
    </span>
  )
}
